import React from 'react';
import './GradientButton.scss';
import { motion } from 'framer-motion';
interface GradientBtn {
  text: string;
  link?: string;
  svg?: string;
  noMarginTop?: boolean;
  onClick?: () => void;
}

export default function GradientButton({
  text,
  link,
  svg,
  noMarginTop,
  onClick,
}: GradientBtn) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className={`buttons ${!noMarginTop && 'mt-5'}`}
    >
      <a href={link ?? '#'} className='btn-icon btn-gradient' onClick={onClick}>
        <ButtonIcon icon={svg ?? ''} />
        <span>{text}</span>
      </a>
    </motion.div>
  );
}

const ButtonIcon = ({ icon }: { icon: string }) => {
  return icon === 'send' ? (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
      <path
        className='fa-secondary'
        d='M511.623 36.863l-64 415.997c-1.5 9.734-7.375 18.218-15.968 23.047-4.844 2.718-10.25 4.093-15.657 4.093-4.187 0-8.343-.812-12.312-2.468l-122.641-51.1L191.998 512V394.98c0-7.116 2.373-14.028 6.743-19.645L415.998 96.004 122.332 360.302 19.686 317.533C8.436 312.845.811 302.158.061 289.986s5.469-23.718 16.062-29.765l448-255.998c10.688-6.109 23.875-5.547 34 1.406s15.375 19.094 13.5 31.234z'
      ></path>
      <path
        className='fa-primary'
        d='M415.666 96.004L198.408 375.335c-4.369 5.617-6.742 12.529-6.742 19.645V512L122 360.302 415.666 96.004z'
      ></path>
    </svg>
  ) : icon === 'learnMore' ? (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512'>
      <path
        className='fa-secondary'
        d='M592 0H208c-26.5 0-48 22.25-48 49.625V96c23.418 0 45.096 6.781 64 17.807V64h352v288H287.313c22.074 16.484 39.535 38.496 50.759 64H592c26.498 0 47.998-22.25 47.998-49.625V49.625C639.998 22.25 618.498 0 592 0z'
      ></path>
      <path
        className='fa-primary'
        d='M160 320c53.02 0 96-42.982 96-96 0-53.02-42.98-96-96-96-53.018 0-96 42.98-96 96 0 53.018 42.982 96 96 96zm32 32h-64C57.307 352 0 409.307 0 480c0 17.672 14.326 32 32 32h256c17.674 0 32-14.328 32-32 0-70.693-57.307-128-128-128zm32-288v49.805c38.072 22.205 64 63.033 64 110.195 0 41.807-20.145 78.996-51.24 102.371 18.529 5.406 35.455 14.354 50.554 25.629h96.688v-48c0-8.838 7.164-16 16-16h96c8.836 0 16 7.162 16 16v48h64V64H224z'
      ></path>
    </svg>
  ) : icon === 'website' ? (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'>
      <path
        className='fa-secondary'
        d='M424 464h-72l-16-48h-96l-16 48h-72c-13.2 0-24 10.8-24 24s10.8 24 24 24h272c13.25 0 24-10.75 24-24s-10.7-24-24-24zM64 64v224h448V64H64z'
      ></path>
      <path
        className='fa-primary'
        d='M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 288H64V64h448v224z'
      ></path>
    </svg>
  ) : icon === 'ecommerce' ? (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'>
      <path
        className='fa-secondary'
        d='M176 416c-26.51 0-47.1 21.49-47.1 48s20.6 48 47.1 48 47.1-21.49 47.1-48-20.6-48-47.1-48zm100.6-235.4h38.86v38.85C315.4 230.7 324.7 240 336 240s20.57-9.257 20.57-20.57V180.6h38.86c11.27 0 20.57-9.3 20.57-20.6 0-11.31-9.256-20.57-20.57-20.57h-38.86V100.6c0-11.31-9.26-20.57-20.57-20.57s-20.57 9.256-20.57 20.57v38.85H276.6C265.3 139.4 256 148.7 256 160s9.3 20.6 20.6 20.6zM488 336H179.9L119.6 19.51C117.4 8.19 107.5 0 96 0H23.1C10.75 0 0 10.75 0 23.1S10.75 48 23.1 48h52.14l60.28 316.5C138.6 375.8 148.5 384 160 384h328c13.25 0 24-10.75 24-23.1 0-14.2-10.7-24.9-24-24.9zm-24.9 80c-26.51 0-47.1 21.49-47.1 48s21.49 48 47.1 48 47.1-21.49 47.1-48-19.7-48-47.1-48z'
      ></path>
      <path
        className='fa-primary'
        d='M569.5 44.73C563.4 36.64 554.1 32 543.1 32h-422l48.76 256h318.4c14.23 0 26.88-9.557 30.77-23.21l54.86-191.1c3.61-10.64 1.71-20.86-4.39-28.96zM395.4 180.6h-38.86v38.85C356.6 230.7 347.3 240 336 240s-20.57-9.257-20.57-20.57V180.6H276.6c-11.3 0-20.6-9.3-20.6-20.6s9.3-20.6 20.6-20.6h38.86v-38.8c0-11.31 9.259-20.57 20.57-20.57s20.57 9.256 20.57 20.57v38.85h38.86C406.7 139.4 416 148.7 416 160s-9.3 20.6-20.6 20.6z'
      ></path>
    </svg>
  ) : icon === 'seo' ? (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'>
      <path
        className='fa-secondary'
        d='M559.7 288l-237.2-.0006 157.1 158c6.124 6.124 15.99 6.484 22.24.7343 38.62-36.5 65.25-85.62 73.12-140.9C577.2 296.4 569.4 288 559.7 288zm-16.6-64.8C534.851 103.7 439.4 9.1 319.9 0c-9.124-.6249-16.76 7.113-16.76 16.24L304 240l223.7-.0012c9.2.0012 16.9-7.5988 15.4-16.7988z'
      ></path>
      <path
        className='fa-primary'
        d='M411.9 443.9c6.874 6.874 6.387 18.49-1.612 24.11-38.25 27.12-84.88 43.38-135.2 44-128.1 1.625-238.5-103.5-242.9-231.6-4.25-124.7 86.88-228.9 205.1-245.7 9.499-1.375 17.87 6.485 17.87 16.11v237.3L411.9 443.9z'
      ></path>
    </svg>
  ) : icon === 'hosting' ? (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
      <path
        className='fa-secondary'
        d='M0 405.3V448c0 35.25 85.1 64 192 64 105.1 0 192-28.75 192-64v-42.75C342.8 434.4 267.3 448 192 448S41.25 434.4 0 405.3zm0-104.9V352c0 35.25 85.1 64 192 64 105.1 0 192-28.75 192-64v-51.6c-41.2 34-116.9 51.6-192 51.6S41.25 334.4 0 300.4zM192 320c105.1 0 192-35.75 192-80s-86.9-80-192-80C85.1 160 0 195.8 0 240s85.1 80 192 80z'
      ></path>
      <path
        className='fa-primary'
        d='M320 128c105.1 0 192-28.75 192-64S426 0 320 0C213.1 0 128 28.75 128 64s85.1 64 192 64zm96 183.4c57.3-11.2 96-31.6 96-55.4v-42.8c-23.25 16.5-57.25 27.63-96 34.5v63.7zm-4.8-95.2c60.1-10.7 100.8-32 100.8-56.2v-42.8c-35.5 25.13-96.5 38.63-160.8 41.88 29.6 14.32 51.3 33.52 60 57.12z'
      ></path>
    </svg>
  ) : icon === 'graphic-design' ? (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'>
      <path
        className='fa-secondary'
        d='M203.6 290.2c-6.4-2.1-12.8-2.2-19.3-3.1-.0313 0 0 0 0 0-57.5 0-103.7 46.51-103.7 103.9 0 7.199.5757 8.954.5757 13.2 0 23.95-18.85 42.94-49.15 42.94C14.33 447.1 0 462.3 0 479.1 0 497.7 14.33 512 32 512h53.72c136.1 0 201.8-44.12 201.8-119.6 0-6.758-.6414-13.52-1.917-20.18L203.6 290.2zM576 56c0-29.84-24.9-56-56-56-14.33 0-28.66 5.469-39.59 16.41L227.7 269.1l79.19 79.19 252.7-252.7C570.5 84.66 576 70.33 576 56z'
      ></path>
      <path
        className='fa-primary'
        d='M205.3 60.08l-46-46.01C149.9 4.691 137.6 0 125.3 0s-24.6 4.691-33.99 14.07L46.06 59.32C36.69 68.7 32 80.99 32 93.28s4.688 24.59 14.06 33.96l115 115c7.64-1.14 15.34-2.24 23.24-2.24 1.562 0 3.094.0313 4.594.0938l98.22-98.22L205.3 60.08zM526.6 389.6c-1.133-6.486-4.24-12.46-8.895-17.12l-83.6-83.59-98.73 98.73c.0348 1.154.0516 2.307.0516 3.458 0 7.949-.7984 15.82-1.95 23.6l70.96 70.96c4.65 4.65 10.62 7.754 17.1 8.889l97.53 17.1c1.263.2215 2.512.3278 3.738.3278 11.62 0 21.17-9.548 21.17-21.16 0-1.222-.1057-2.467-.3259-3.726L526.6 389.6z'
      ></path>
    </svg>
  ) : icon === 'eye' ? (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'>
      <path
        className='fa-secondary'
        d='M572.531 238.973C518.281 115.525 410.938 32 288 32S57.688 115.58 3.469 238.973C1.562 243.402 0 251.041 0 256c0 4.977 1.562 12.596 3.469 17.025C57.719 396.473 165.062 480 288 480s230.312-83.582 284.531-206.975C574.438 268.596 576 260.957 576 256c0-4.977-1.562-12.598-3.469-17.027zM432 256.062C432 335.516 367.531 400 288.062 400H288c-79.5 0-144-64.516-144-144s64.5-144 144-144 144 64.516 144 144v.062z'
      ></path>
      <path
        className='fa-primary'
        d='M288 160h-.219c-2.301.029-5.355.441-8.242.764C284.77 170.037 288 180.594 288 192c0 35.346-28.654 64-64 64-11.449 0-22.041-3.252-31.34-8.518-.297 2.997-.66 6.143-.66 8.518 0 52.996 43.004 96 96 96s96-43.004 96-96-43.004-96-96-96z'
      ></path>
    </svg>
  ) : icon === 'code' ? (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512'>
      <path
        className='fa-secondary'
        d='M176 143.1c0-18.28-14.95-32-32-32-8.188 0-16.38 3.125-22.62 9.376l-112 112C3.125 239.6 0 247.8 0 255.1s3.125 17.3 9.375 23.5l112 112c6.225 6.3 14.425 8.5 22.625 8.5 17.05 0 32-13.73 32-32 0-8.188-3.125-16.38-9.375-22.63L77.25 255.1l89.38-89.38c6.27-5.42 9.37-13.52 9.37-22.62zm464 112c0-8.188-3.125-16.38-9.375-22.63l-112-112C512.4 115.1 504.2 111.1 496 111.1c-17.05 0-32 13.73-32 32 0 8.188 3.125 16.38 9.375 22.63l89.38 89.38-89.38 89.38C467.1 351.6 464 359.8 464 367.1c0 18.28 14.95 32 32 32 8.188 0 16.38-3.125 22.62-9.376l112-112C636.9 272.4 640 264.2 640 255.1z'
      ></path>
      <path
        className='fa-primary'
        d='M416 31.94C416 21.75 408.1 0 384.1 0c-13.98 0-26.87 9.072-30.89 23.18l-128 448c-.8404 2.935-1.241 5.892-1.241 8.801C223.1 490.3 232 512 256 512c13.92 0 26.73-9.157 30.75-23.22l128-448c.85-2.97 1.25-5.93 1.25-8.84z'
      ></path>
    </svg>
  ) : (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512'>
      <path
        className='fa-secondary'
        d='M480 128.224c-40.979-40.93-64.557-63.927-122.51-63.927-10.494 0-19.978-.812-30.24 8.368L217 163.563c-20.25 17.112-22.766 47.401-5.641 67.604 9.5 11.21 23.032 16.987 36.672 16.987 10.938 0 21.953-3.716 30.969-11.335l33.59-28.4h.002l5.982-5.058 165.301 135.387c4.361 3.536 7.092 8.119 9.047 12.982H544V128.458l-64-.234zM0 383.932h64c17.75 0 32-14.239 32-31.968V128.458H0v255.474zm48-63.806c8.75 0 16 7.115 16 15.983 0 8.736-7.25 15.98-16 15.98s-16-7.244-16-15.98c0-8.868 7.25-15.983 16-15.983z'
      ></path>
      <path
        className='fa-primary'
        d='M318.574 203.361L279 236.819c-9.016 7.619-20.031 11.335-30.969 11.335-13.64 0-27.172-5.777-36.672-16.987-17.125-20.203-14.609-50.492 5.641-67.604l110.25-90.898L280.945 64c-57.312.375-112.193 23.611-152.795 64.075l-.15.149-32 .234v223.397h50.25l90.5 81.788c27.5 22.35 67.75 18.103 90-9.243l.25-.249 17.875 15.488c15.875 12.982 39.375 10.484 52.375-5.371l31.375-38.587 5.374 4.496c13.751 10.991 33.876 8.993 45.001-4.746l9.576-11.827c11.08-13.693 8.979-33.755-4.701-44.856L318.574 203.361zM544 128.458v223.631c0 17.604 14.25 31.968 32 31.968h64V128.458h-96zm48 223.631c-8.75 0-16-7.244-16-15.98 0-8.868 7.25-15.983 16-15.983s16 7.115 16 15.983c0 8.736-7.25 15.98-16 15.98z'
      ></path>
    </svg>
  );
};
